export const SNIPPET_CATEGORIES = [
    { value: "ALL", label: "Todas las categorías" },
    { value: "FRONTEND", label: "Frontend / Web" },
    { value: "BACKEND", label: "Backend / APIs" },
    { value: "FULLSTACK", label: "Full stack" },
    { value: "MOBILE", label: "Mobile" },
    { value: "DESKTOP", label: "Desktop" },
    { value: "DATABASE", label: "Bases de datos" },
    { value: "DEVOPS", label: "DevOps / Infra" },
    { value: "CLOUD", label: "Cloud" },
    { value: "CONTAINERS", label: "Containers / Orquestación" },
    { value: "CI_CD", label: "CI/CD" },
    { value: "DATA_AI", label: "Datos / IA" },
    { value: "ML", label: "Machine Learning" },
    { value: "AUTOMATION", label: "Automatización / Scripts" },
    { value: "SECURITY", label: "Seguridad" },
    { value: "TESTING", label: "Testing / QA" },
    { value: "NETWORKING", label: "Redes" },
    { value: "EMBEDDED", label: "Embebidos / IoT" },
    { value: "GAMEDEV", label: "Game Dev" },
    { value: "CMS", label: "CMS / Ecommerce" },
    { value: "CONFIG", label: "Configuración" },
    { value: "COMMANDS", label: "Comandos / terminal" },
    { value: "ALGORITHMS", label: "Algoritmos / estructuras" },
    { value: "UTILITIES", label: "Utilidades" },
    { value: "OTHER", label: "Otros" },
];

export const LANGUAGE_OPTIONS = [
    ["text", "Texto plano"], ["markdown", "Markdown"], ["mdx", "MDX"],
    ["html", "HTML"], ["css", "CSS"], ["scss", "SCSS"], ["sass", "Sass"], ["less", "Less"],
    ["javascript", "JavaScript"], ["jsx", "JavaScript JSX"], ["typescript", "TypeScript"], ["tsx", "TypeScript TSX"],
    ["json", "JSON"], ["json5", "JSON5"], ["yaml", "YAML"], ["toml", "TOML"], ["xml", "XML"], ["csv", "CSV"],
    ["python", "Python"], ["php", "PHP"], ["ruby", "Ruby"], ["perl", "Perl"], ["lua", "Lua"], ["r", "R"], ["julia", "Julia"],
    ["java", "Java"], ["kotlin", "Kotlin"], ["scala", "Scala"], ["groovy", "Groovy"], ["clojure", "Clojure"],
    ["c", "C"], ["cpp", "C++"], ["csharp", "C#"], ["objective-c", "Objective-C"], ["swift", "Swift"],
    ["go", "Go"], ["rust", "Rust"], ["dart", "Dart"], ["elixir", "Elixir"], ["erlang", "Erlang"], ["haskell", "Haskell"], ["ocaml", "OCaml"],
    ["fsharp", "F#"], ["vbnet", "Visual Basic .NET"], ["delphi", "Delphi / Pascal"], ["fortran", "Fortran"], ["cobol", "COBOL"],
    ["sql", "SQL"], ["mysql", "MySQL"], ["postgresql", "PostgreSQL"], ["plsql", "PL/SQL"], ["tsql", "T-SQL"], ["sqlite", "SQLite"],
    ["graphql", "GraphQL"], ["prisma", "Prisma"], ["mongodb", "MongoDB / MQL"], ["redis", "Redis"],
    ["bash", "Bash"], ["shell", "Shell / sh"], ["zsh", "Zsh"], ["fish", "Fish"], ["powershell", "PowerShell"], ["batch", "Batch / CMD"],
    ["dockerfile", "Dockerfile"], ["docker-compose", "Docker Compose"], ["kubernetes", "Kubernetes"], ["helm", "Helm"],
    ["hcl", "HCL / Terraform"], ["ansible", "Ansible"], ["nginx", "Nginx"], ["apache", "Apache"],
    ["github-actions", "GitHub Actions"], ["gitlab-ci", "GitLab CI"], ["jenkins", "Jenkinsfile"],
    ["makefile", "Makefile"], ["cmake", "CMake"], ["gradle", "Gradle"], ["maven", "Maven / POM"],
    ["vue", "Vue"], ["svelte", "Svelte"], ["astro", "Astro"], ["angular", "Angular template"],
    ["react", "React"], ["nextjs", "Next.js"], ["nestjs", "NestJS"],
    ["svg", "SVG"], ["protobuf", "Protocol Buffers"], ["solidity", "Solidity"], ["wasm", "WebAssembly"],
    ["ini", "INI"], ["dotenv", ".env"], ["properties", "Properties"], ["editorconfig", "EditorConfig"],
    ["regex", "Expresión regular"], ["http", "HTTP request"], ["other", "Otro / personalizado"],
].map(([value, label]) => ({ value, label }));

export const LANGUAGE_BY_EXTENSION = {
    txt: "text", md: "markdown", mdx: "mdx", html: "html", htm: "html", css: "css", scss: "scss", sass: "sass", less: "less",
    js: "javascript", mjs: "javascript", cjs: "javascript", jsx: "jsx", ts: "typescript", tsx: "tsx", json: "json", json5: "json5", yml: "yaml", yaml: "yaml", toml: "toml", xml: "xml", csv: "csv",
    py: "python", php: "php", rb: "ruby", pl: "perl", lua: "lua", r: "r", jl: "julia", java: "java", kt: "kotlin", kts: "kotlin", scala: "scala", groovy: "groovy", clj: "clojure",
    c: "c", h: "c", cpp: "cpp", cc: "cpp", cxx: "cpp", hpp: "cpp", cs: "csharp", m: "objective-c", mm: "objective-c", swift: "swift", go: "go", rs: "rust", dart: "dart", ex: "elixir", exs: "elixir", erl: "erlang", hs: "haskell", ml: "ocaml", fs: "fsharp", vb: "vbnet", pas: "delphi", f90: "fortran", cob: "cobol",
    sql: "sql", graphql: "graphql", gql: "graphql", prisma: "prisma", sh: "shell", zsh: "zsh", fish: "fish", ps1: "powershell", bat: "batch", cmd: "batch", tf: "hcl", hcl: "hcl", proto: "protobuf", sol: "solidity", ini: "ini", env: "dotenv", properties: "properties", svg: "svg",
};

export const languageFromFileName = (name = "") => {
    const lower = String(name || "").trim().toLowerCase();
    if (lower === "dockerfile" || lower.startsWith("dockerfile.")) return "dockerfile";
    if (lower === "makefile") return "makefile";
    if (lower === "jenkinsfile") return "jenkins";
    if (lower === ".gitlab-ci.yml" || lower === ".gitlab-ci.yaml") return "gitlab-ci";
    if (lower.endsWith("docker-compose.yml") || lower.endsWith("docker-compose.yaml") || lower.endsWith("compose.yml") || lower.endsWith("compose.yaml")) return "docker-compose";
    return LANGUAGE_BY_EXTENSION[extensionFromName(lower)] || "";
};

export const categoryLabel = (value) => SNIPPET_CATEGORIES.find((item) => item.value === value)?.label || value || "Otros";
export const tagsToText = (tags) => Array.isArray(tags) ? tags.join(", ") : "";
export const textToTags = (value) => [...new Set(String(value || "").split(",").map((item) => item.trim()).filter(Boolean))].slice(0, 40);
export const formatSize = (bytes) => {
    const value = Number(bytes || 0);
    if (value < 1024) return `${value} B`;
    if (value < 1048576) return `${(value / 1024).toFixed(value >= 10240 ? 0 : 1)} KB`;
    return `${(value / 1048576).toFixed(1)} MB`;
};
export const formatDateTime = (value) => value ? new Date(value).toLocaleString("es-AR", { dateStyle: "medium", timeStyle: "short" }) : "-";
export const extensionFromName = (name = "") => String(name).includes(".") ? String(name).split(".").pop().toLowerCase() : "";
export const isPreviewLanguage = (file) => ["html", "css", "javascript"].includes(file?.language) || ["html", "htm", "css", "js", "mjs", "cjs"].includes(extensionFromName(file?.name));

export const getFolderDescendants = (folders = [], rootId) => {
    const ids = new Set([rootId]);
    let changed = true;
    while (changed) {
        changed = false;
        folders.forEach((folder) => {
            if (folder.parentId && ids.has(folder.parentId) && !ids.has(folder.id)) {
                ids.add(folder.id); changed = true;
            }
        });
    }
    return ids;
};

export const buildFolderTree = (folders = []) => {
    const map = new Map(folders.map((folder) => [folder.id, { ...folder, children: [] }]));
    const roots = [];
    map.forEach((folder) => {
        const parent = folder.parentId ? map.get(folder.parentId) : null;
        if (parent) parent.children.push(folder); else roots.push(folder);
    });
    const sort = (items) => items.sort((a, b) => (a.position - b.position) || a.name.localeCompare(b.name)).map((item) => ({ ...item, children: sort(item.children) }));
    return sort(roots);
};

export const rebuildTreePaths = (tree) => {
    if (!tree) return tree;
    const folders = (tree.folders || []).map((folder) => ({ ...folder }));
    const byId = new Map(folders.map((folder) => [folder.id, folder]));
    const memo = new Map();
    const pathFor = (folder, seen = new Set()) => {
        if (!folder) return "";
        if (memo.has(folder.id)) return memo.get(folder.id);
        if (seen.has(folder.id)) return folder.name;
        seen.add(folder.id);
        const parent = folder.parentId ? byId.get(folder.parentId) : null;
        const value = parent ? `${pathFor(parent, seen)}/${folder.name}` : folder.name;
        memo.set(folder.id, value);
        return value;
    };
    folders.forEach((folder) => { folder.path = pathFor(folder); });
    const files = (tree.files || []).map((file) => {
        const folderPath = file.folderId ? (byId.get(file.folderId)?.path || "") : "";
        return { ...file, folderPath, path: [folderPath, file.name].filter(Boolean).join("/") };
    });
    return { ...tree, folders, files };
};
